<template>
  <div class="va-audio-file-input">
    <v-file-input
      @change="fileChanged"
      :value="file"
      :loading="loading"
      :label="label"
      accept=".mp3, .wav"></v-file-input>
  </div>
</template>

<script>
  import { sendToServer } from "../../utility/mediaObjectUploadHelper";
  import { formErrorMessage } from "@/utility/formErrorMessage";

  export default {
    name: "VaAudioFileInput",
    props: {
      fileId: {
        type: String,
        required: false,
        default: "",
      },
      fileName: {
        type: String,
        required: false,
        default: "",
      },
      label: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        loading: false,
        file: null,
      };
    },
    watch: {
      fileName: {
        immediate: true,
        handler(val) {
          if (val) {
            try {
              const file = new File([""], val);
              this.file = file;
            } catch (e) {
              console.log(e);
            }
          } else {
            this.file = null;
          }
        },
      },
    },
    methods: {
      async fileChanged(file) {
        // Prevent empty file upload
        if (file && file.size === 0) {
          return;
        }
        if (file) {
          this.loading = true;
          try {
            const res = await sendToServer(file);
            this.file = file;
            this.$emit("update:file", { ...res, fileName: file.name });
          } catch (e) {
            this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
          } finally {
            this.loading = false;
          }
        } else {
          this.$emit("update:file", null);
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
